import { PossibleProductView, useAPI } from '@nexelem/api';
import { useCustomToast } from '@nexelem/snackbar';
import { useCustomTranslation } from '../../../../../../hooks';
import { useMutation } from '@tanstack/react-query';

export type KanbanInProgressToCompletedMutationProps = {
  productionLotId: number;
  oks: number;
  noks: number;
};

export const useKanbanInProgressToCompletedMutation = () => {
  const api = useAPI();
  const displayToast = useCustomToast();
  const { tWrapper } = useCustomTranslation('components.toasts.commonMessage');

  return useMutation({
    onSuccess: () => {
      displayToast({
        toastType: 'success',
        message: tWrapper('success'),
      });
    },
    onError: () => {
      displayToast({
        toastType: 'error',
        message: tWrapper('error'),
      });
    },
    mutationFn: async ({ productionLotId, oks, noks }: KanbanInProgressToCompletedMutationProps) => {
      const possibleProductsData = await api.getBackReportsWorkstationReportsPossibleProductsProductionlotid({
        productionLotId,
      });

      //TODO - there will be more options here when handling byproducts, for now first element is the only one
      const { productVariantId } = possibleProductsData?.[0] || ({} as PossibleProductView);

      await api.postBackReportsWorkstationReportsAmountProductionlotid({
        productionLotId: productionLotId,
        workstationAmountReportSaveView: {
          productVariantId: productVariantId,
          oks,
          noks,
        },
      });

      return await api.postBackReportsWorkstationsByLotProductionlotidFinish({ productionLotId });
    },
  });
};
